
define('text!templates/oAuthError.html',[],function () { return '<div class="oauth-error-container">\n    <div class="oauth-error">\n        <span data-bind="lString: &apos;authentication.oauth.error&apos;"></span>\n    </div>\n</div>\n';});

